import React from 'react';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import type {
  SafetyEventSimpleResponse} from 'src/api/ProactApiClient';
import {
  ModuleEnum,
  PermissionOperationEnum
} from 'src/api/ProactApiClient';
import {SectionTitle} from 'src/design/atoms/Typography';
import {PermissionGuard} from 'src/app/security/authorization/PermissionGuard';
import {SafetyEventTable} from 'src/app/safety-events/SafetyEventTable/SafetyEventTable';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface AssetSafetyEventListProps {
  assetId: number;
}
export const AssetSafetyEventList: React.FC<AssetSafetyEventListProps> = ({
  assetId,
}) => {
  const navigate = useAppNavigate();

  const handleNavigateTo = (row: SafetyEventSimpleResponse) =>
    navigate(PathUtility.SafetyEventView(String(row.id), 'content'));

  return (
    <PermissionGuard
      module={ModuleEnum.SafetyEvent}
      operation={PermissionOperationEnum.View}
      showDeniedMessage={true}>
      <SectionTitle text="Safety Events" />
      <SafetyEventTable
        identifier={'asset-safety-event-table'}
        onViewRowClick={handleNavigateTo}
        filterAssetId={assetId}
      />
    </PermissionGuard>
  );
};
